import { bikiniSectionTypes } from "./groups/bikini/types";
import { bikini2026SectionTypes } from "./groups/bikini2026/types";
import { bikiniContinueSectionTypes } from "./groups/bikiniContinue/types";
import { commonSectionTypes } from "./groups/common/types";
import { postPurchaseSectionTypes } from "./groups/postPurchase/types";
import { resetSectionTypes } from "./groups/reset/types";

/** Section types of the funnel templates, appended to `landingSectionTypes`. */
export const funnelSectionTypes = [
  ...commonSectionTypes,
  ...bikiniSectionTypes,
  ...bikini2026SectionTypes,
  ...resetSectionTypes,
  ...postPurchaseSectionTypes,
  ...bikiniContinueSectionTypes,
] as const;

export type FunnelSectionType = (typeof funnelSectionTypes)[number];
